// extracted by mini-css-extract-plugin
export default {"well":"styles_well__r7xG1"};